export const initElement = function () {
  const cardBtn = document.querySelectorAll('[data-element]');


  if (cardBtn.length > 0) {
    cardBtn.forEach((item) => {
      item.addEventListener('click', (evt) => {
        evt.preventDefault();
        const parent = item.closest('[data-element-parent]');

        if (parent) {
          if (parent.classList.contains('is-active')) {
            parent.classList.remove('is-active');
          } else {
            parent.classList.add('is-active');
            if (parent.closest('[data-element-parent-basket]')) {
              const inputCounter = parent.querySelector('[data-counter="input"]');
              const inputCounterValue = Number(inputCounter.value);
              inputCounter.value = inputCounterValue + 1;
            }
          }
        }

        if (item.closest('[data-element-more]')) {
          const textLink = item.querySelector('.catalog-page__more-text');
          if (textLink) {
            if (parent.classList.contains('is-active')) {
              textLink.textContent = 'Свернуть ';
            } else {
              textLink.textContent = 'Смотреть все категории ';
            }
          }
        }
      })
    })
  }
}
